/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DomainService API
 * API reference for handling domain data provided by DomainService.
 *
 * # Authentication
 * This API is stateful. Therefore, it is necessary to call with the authentication information set in the cookie.
 * More specifically, it authenticates using Auth0.
 * Please set in header before calling API
 *  - x-solution-id
 *  - x-client-id
 *  - Authorization
 *  - Cookie.
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  ArrangeRequest,
  BaseSuccessResponse,
  ConditionResponse,
  ConditionsResponse,
  StoreConditionsBody,
  UpdateConditionBody
} from '../model';

import listConditionsMutator from '../../../mutators/domain-service-instance';
import storeConditionsMutator from '../../../mutators/domain-service-instance';
import updateConditionMutator from '../../../mutators/domain-service-instance';
import deleteConditionMutator from '../../../mutators/domain-service-instance';
import arrangeConditionMutator from '../../../mutators/domain-service-instance';
import arrangeDamageAttributeMutator from '../../../mutators/domain-service-instance';



  /**
 * Returns a list of (abnormal) conditions of organizations. sorting based on sort_order ascending.
 * @summary List conditions
 */
export const listConditions = (

 ) => {
      return listConditionsMutator<ConditionsResponse>(
      {url: `/conditions`, method: 'GET'
    },
      );
    }
  /**
 * Store condition. Condition name must unique.
 * @summary Store condition
 */
export const storeConditions = (
    storeConditionsBody: StoreConditionsBody,
 ) => {
      return storeConditionsMutator<ConditionResponse>(
      {url: `/conditions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: storeConditionsBody
    },
      );
    }
  /**
 * Update condition
 * @summary Update Condition
 */
export const updateCondition = (
    id: number,
    updateConditionBody: UpdateConditionBody,
 ) => {
      return updateConditionMutator<ConditionResponse>(
      {url: `/conditions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateConditionBody
    },
      );
    }
  /**
 * Delete condition
 * @summary Delete Condition
 */
export const deleteCondition = (
    id: number,
 ) => {
      return deleteConditionMutator<BaseSuccessResponse>(
      {url: `/conditions/${id}`, method: 'DELETE'
    },
      );
    }
  /**
 * Arrange condition (sort order)
 * @summary Arrange condition
 */
export const arrangeCondition = (
    arrangeRequest: ArrangeRequest,
 ) => {
      return arrangeConditionMutator<BaseSuccessResponse>(
      {url: `/conditions/arrange`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: arrangeRequest
    },
      );
    }
  /**
 * Arrange damage attributes (sort order)
 * @summary Arrange Damage Attributes
 */
export const arrangeDamageAttribute = (
    arrangeRequest: ArrangeRequest,
 ) => {
      return arrangeDamageAttributeMutator<BaseSuccessResponse>(
      {url: `/damage-attributes/arrange`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: arrangeRequest
    },
      );
    }
  export type ListConditionsResult = NonNullable<Awaited<ReturnType<typeof listConditions>>>
export type StoreConditionsResult = NonNullable<Awaited<ReturnType<typeof storeConditions>>>
export type UpdateConditionResult = NonNullable<Awaited<ReturnType<typeof updateCondition>>>
export type DeleteConditionResult = NonNullable<Awaited<ReturnType<typeof deleteCondition>>>
export type ArrangeConditionResult = NonNullable<Awaited<ReturnType<typeof arrangeCondition>>>
export type ArrangeDamageAttributeResult = NonNullable<Awaited<ReturnType<typeof arrangeDamageAttribute>>>
